import type { RestangularService } from '../common/restangular.service'

import { app } from '../../app.module'

export interface ICarousel {
  sequenceNo: number
  imageUrl?: string
  videoUrl?: string
  type: string
}
/**
 * 投稿画像表示用サビース
 * @param  {function} $rootScope $rootScope
 * @param  {function} Restangular Restangular
 * @param  {function} $q Promise用
 * @return {object} オブジェクト
 */
function LightboxModalService(Restangular, $q, RestangularService: RestangularService) {
  /**
   * 投稿の画像リストを取得
   * @param {Number} postId 投稿ID
   * @param {String} snsType SNSタイプ
   * @return {function} 画像リスト
   */
  function getPostImagesList(postId, snsType) {
    const deferred = $q.defer()
    const query = `?post_id=${postId}&sns_type=${snsType}`

    Restangular.all('/post/getPostImagesList' + query)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
      .catch((error) => {
        deferred.reject(error)
      })

    return deferred.promise
  }

  /**
   * 投稿の動画URLを取得
   * @param {Number} accountId アカウントID
   * @param {Number} postId 投稿ID
   * @param {String} snsType SNSタイプ
   * @return {function} 動画URL
   */
  function getPostVideo(accountId, postId, snsType) {
    const deferred = $q.defer()
    const query = `?account_id=${accountId}&post_id=${postId}&sns_type=${snsType}`

    Restangular.all('/post/getPostVideo' + query)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })

    return deferred.promise
  }

  /**
   * 投稿のカルーセルを取得
   * @param {String} postId 投稿ID
   * @return {ng.IPromise <ICarousel[]>} カルーセルデータ
   */
  function getCarousel(postId: string, snsType: string): ng.IPromise<ICarousel[]> {
    const deferred = $q.defer()
    const endPoint = '/post/carousel'

    RestangularService.request('GET', endPoint, {
      postId: postId,
      snsType: snsType,
    })
      .then((result) => {
        deferred.resolve(result[0].data)
      })
      .catch(() => {
        deferred.resolve([])
      })

    return deferred.promise
  }

  /**
   * リンク投稿の画像を取得
   * @param {Number} postId 投稿ID
   * @param {String} snsType SNSタイプ
   * @return {function} 画像リスト
   */
  function getLinkPostImage(postId, snsType) {
    const deferred = $q.defer()
    const query = `?post_id=${postId}&sns_type=${snsType}`

    Restangular.all('/post/linkImage' + query)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
      .catch((error) => {
        deferred.reject(error)
      })

    return deferred.promise
  }

  return {
    getPostImagesList: getPostImagesList,
    getPostVideo: getPostVideo,
    getCarousel: getCarousel,
    getLinkPostImage: getLinkPostImage,
  }
}

app.factory('LightboxModalService', LightboxModalService)
